import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const kycTabs = [
  {
    label: "ACT ID (KYC)",
    isHeader: true,
  },
  {
    label: "Overview",
    slug: "kyc-overview"
  },
  {
    label: "Form Integration Guide",
    // Slug kept from the old "ACT ID Integration" page so existing links work.
    slug: "kyc-id-integration"
  },
  {
    label: "Build with LLM",
    slug: "kyc-build-with-llm"
  },
];

export function getIndexFromSlug(slug) {
  const contentTabs = kycTabs.filter((t) => !t.isHeader);
  const index = contentTabs.findIndex((t) => t.slug === slug);
  return index >= 0 ? index : 0;
}

export function getSlugFromIndex(index) {
  const contentTabs = kycTabs.filter((t) => !t.isHeader);
  return contentTabs[index]?.slug ?? contentTabs[0].slug;
}

export default function KycTabs({ value, onChange }) {
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    const headersBefore = kycTabs
      .slice(0, newValue)
      .filter((t) => t.isHeader).length;
    const actualContentIndex = newValue - headersBefore;

    const slug = getSlugFromIndex(actualContentIndex);
    navigate(`/kyc/${slug}`);

    onChange(actualContentIndex);
  };

  let visualIndex = 0;
  let clickableCount = 0;

  for (let i = 0; i < kycTabs.length; i++) {
    if (!kycTabs[i].isHeader) {
      if (clickableCount === value) {
        visualIndex = i;
        break;
      }
      clickableCount++;
    }
  }

  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={visualIndex}
      onChange={handleChange}
      sx={{
        width: "100%",
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: "400",
          fontSize: "14px",
          minHeight: 40,
          alignItems: "flex-start",
          textAlign: "left",
          borderBottom: "0.1rem #d8d8d8 solid",
          "&:hover": {
            backgroundColor: " #e3e3e3",
          },
        },
        "& .Mui-selected": {
          color: "#e54f9c !important",
          backgroundColor: "#fcd4e9",
        },
        "& .MuiTabs-indicator": {
          width: 0,
        },
      }}
    >
      {kycTabs.map((tab, index) => (
        <Tab
          key={`${tab.label}-${index}`}
          label={tab.label}
          disabled={tab.isHeader}
          {...a11yProps(index)}
          sx={{
            ...(tab.isHeader && {
              opacity: "1 !important",
              color: "#fff !important",
              fontWeight: "bold !important",
              fontSize: "12px",
              backgroundColor: "#000000",
              cursor: "default",
              pointerEvents: "none",
              letterSpacing: "0.05rem",
              marginTop: "0",
            }),
          }}
        />
      ))}
    </Tabs>
  );
}
